// Module
var code = " <div class=\"chart-axis\"> <div class=\"chart-axis-label\" *ngFor=\"let label of labels\">{{ label }}</div> </div> ";
// Exports
module.exports = code;